import { render, staticRenderFns } from "./OverlaysDemo.vue?vue&type=template&id=24a46ef9&scoped=true&"
import script from "./OverlaysDemo.vue?vue&type=script&lang=js&"
export * from "./OverlaysDemo.vue?vue&type=script&lang=js&"
import style0 from "./OverlaysDemo.vue?vue&type=style&index=0&id=24a46ef9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a46ef9",
  null
  
)

export default component.exports